import Alpine from "alpinejs";
import { $http } from "../../utils";

if (window.category || window.collection || window.isSale || window.isAll) {
    Alpine.store('catalog', {
        products: [],
        categoryId: null,
        colors: [],
        sizes: [],
        attributes: new Map(),
        order: null,
        minPrice: 0,
        maxPrice: 0,
        filterView: false,
        currentPage: 1,
        perPage: 12,
        nextPage: false,

        init() {
            if (window.category) {
                this.categoryId = window.category.id;
            }
            else if(window.collection) {
                this.categoryId = window.collection.id;
            }
            else if(window.isSale || window.isAll) {
                this.categoryId = -1;
            }
            this.minPrice = window.minPrice;
            this.maxPrice = window.maxPrice;

            this.applyFilters();
        },

        setOrder(orderType) {
            this.order = orderType
            this.applyFilters();
        },

        getProducts() {
            return this.products || [];
        },

        applyFilters() {
            this.products = [];
            this.filterView = true;
            this.currentPage = 1;
            let url = '';
            if (window.category) {
                url = `/api/v1/filter/${this.categoryId}?sizes=${this.sizes.join(",")}&colors=${this.colors.join(",")}&price_from=${this.minPrice}&price_to=${this.maxPrice}&order=${this.order}&per_page=${this.perPage}&page=${this.currentPage}`;
            }
            else if(window.collection) {
                url = `/api/v1/collection_filter/${this.categoryId}?sizes=${this.sizes.join(",")}&colors=${this.colors.join(",")}&price_from=${this.minPrice}&price_to=${this.maxPrice}&order=${this.order}&per_page=${this.perPage}&page=${this.currentPage}`;
            }
            else if(window.isSale) {
                url = `/api/v1/sale_filter/?sizes=${this.sizes.join(",")}&colors=${this.colors.join(",")}&price_from=${this.minPrice}&price_to=${this.maxPrice}&order=${this.order}&per_page=${this.perPage}&page=${this.currentPage}`;
            }
            else if(window.isAll) {
                url = `/api/v1/all_filter/?sizes=${this.sizes.join(",")}&colors=${this.colors.join(",")}&price_from=${this.minPrice}&price_to=${this.maxPrice}&order=${this.order}&per_page=${this.perPage}&page=${this.currentPage}`;
            }

            this.attributes.forEach((value, key) => {
                url += `&${key}=${value.join(",")}`;
            });

            $http.get(url).then(response => {
                this.products = response.data.data;
                if(!!response.data.links.next) {
                    this.nextPage = true;
                    this.currentPage += 1;
                }
            }).catch((e) => {
                console.error(e);
            });
        },

        loadMore() {
            let url = '';
            if (window.category) {
                url = `/api/v1/filter/${this.categoryId}?sizes=${this.sizes.join(",")}&colors=${this.colors.join(",")}&price_from=${this.minPrice}&price_to=${this.maxPrice}&order=${this.order}&per_page=${this.perPage}&page=${this.currentPage}`;
            }
            else if(window.collection) {
                url = `/api/v1/collection_filter/${this.categoryId}?sizes=${this.sizes.join(",")}&colors=${this.colors.join(",")}&price_from=${this.minPrice}&price_to=${this.maxPrice}&order=${this.order}&per_page=${this.perPage}&page=${this.currentPage}`;
            }
            else if(window.isSale) {
                url = `/api/v1/sale_filter/?sizes=${this.sizes.join(",")}&colors=${this.colors.join(",")}&price_from=${this.minPrice}&price_to=${this.maxPrice}&order=${this.order}&per_page=${this.perPage}&page=${this.currentPage}`;
            }
            else if(window.isAll) {
                url = `/api/v1/all_filter/?sizes=${this.sizes.join(",")}&colors=${this.colors.join(",")}&price_from=${this.minPrice}&price_to=${this.maxPrice}&order=${this.order}&per_page=${this.perPage}&page=${this.currentPage}`;
            }

            this.attributes.forEach((value, key) => {
                url += `&${key}=${value.join(",")}`;
            });

            $http.get(url).then(response => {
                this.products = [...this.products, ...response.data.data];
                if(!!response.data.links.next) {
                    this.nextPage = true;
                    this.currentPage += 1;
                }
                else {
                    this.nextPage = false;
                    this.currentPage += 1;
                }
            }).catch((e) => {
                console.error(e);
            });
        },

        toggleAttribute(attribute, id) {
            if (this.attributes.has(attribute)) {
                const attrArray = this.attributes.get(attribute);

                const index = attrArray.indexOf(id);
                if (index === -1) {
                    attrArray.push(id);
                } else {
                    attrArray.splice(index, 1);
                }
            } else {
                this.attributes.set(attribute, [id]);
            }
        },

        toggleColor(id) {
            const index = this.colors.indexOf(id);
            if (index === -1) {
                this.colors.push(id);
            } else {
                this.colors.splice(index, 1);
            }
        },

        toggleSize(id) {
            const index = this.sizes.indexOf(id);
            if (index === -1) {
                this.sizes.push(id);
            } else {
                this.sizes.splice(index, 1);
            }
        },

        checkColor(id) {
            return this.colors.includes(id);
        },

        checkSize(id) {
            return this.sizes.includes(id);
        },

        clearFilters() {
            this.colors = [];
            this.sizes = [];
            this.minPrice = 0;
            this.maxPrice = 0;
            this.attributes = new Map();
            this.filterView = false;
        }
    });
}